import { TextInput } from '@mantine/core';
import React from 'react';
import classes from '../../../core/style/PrintStyles.module.css';
import { CustomTextInputProps } from './CustomTextInput.model';

export function CustomTextInput({
  label,
  inputProps,
  required = false,
  disabled,
  mt
}: CustomTextInputProps) {
  return (
    <TextInput
      {...inputProps}
      // Mantine controlled input nesmí dostat value={null} (varování „value prop on input
      // should not be null"). Pole s prázdnou hodnotou z BE (null) převedeme na '' — hodnota
      // ve form stavu zůstává, jen se komponentě předá prázdný řetězec místo null.
      value={inputProps?.value ?? ''}
      label={label}
      withAsterisk={required}
      id={'print-input-field'}
      disabled={disabled}
      mt={mt || 10}
      radius={10}
      classNames={{
        input: classes.input
      }}
    />
  );
}
